// extracted by mini-css-extract-plugin
module.exports = {"boxWrap":"purify_index__boxWrap--1dTI-","content":"purify_index__content--3n3yS","feeBoxWrap":"purify_index__feeBoxWrap--2bonE"};